import React from "react";

interface ExpandIconProps {
    className?: string;
}

export function ExpandIcon({ className }: ExpandIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className={className}>

            <path d="m3.065 5.54 8.986 9.293 8.985-9.294 2.76 2.861-11.745 12.176L.305 8.4Z" />
        </svg>
    );
}
